import React from "react";

import ReactDOM from "react-dom";

import {
  FiCalendar,
  FiCheck,
  FiClock,
  FiUser,
  FiX,
  FiXCircle,
} from "react-icons/fi";

import EmployeeStatusBadge
  from "../common/EmployeeStatusBadge";

import {
  formatEmployeeDate,
} from "../utils/employee.utils";

import "./EmployeeLeave.css";


const LeaveDetailsDrawer = ({
  open,

  leave,

  onClose,

  onApprove,

  onReject,

  onCancel,
}) => {

  if (
    !open ||
    !leave
  ) {

    return null;

  }


  const employee =
    leave?.employeeId &&
    typeof leave.employeeId ===
      "object"
      ?
      leave.employeeId
      :
      leave?.employee ||
      {};


  const leaveType =
    leave?.leaveTypeId &&
    typeof leave.leaveTypeId ===
      "object"
      ?
      leave.leaveTypeId
      :
      leave?.leaveType ||
      {};


  const status =
    String(
      leave?.status ||
      "PENDING"
    )
      .toUpperCase();


  return ReactDOM
    .createPortal(

      <div className="employee-leave-drawer-root">

        <button
          type="button"
          className="employee-leave-drawer-backdrop"
          onClick={
            onClose
          }
          aria-label="Close"
        />


        <aside className="employee-leave-drawer">

          <header>

            <div>

              <span>
                LEAVE DETAILS
              </span>

              <h2>
                Leave Request
              </h2>

            </div>


            <button
              type="button"
              onClick={
                onClose
              }
            >
              <FiX />
            </button>

          </header>


          <div className="employee-leave-drawer-body">

            <section className="employee-leave-profile">

              <div className="employee-leave-profile-icon">

                <FiUser />

              </div>


              <div>

                <small>
                  {
                    employee?.employeeCode ||
                    leave?.employeeCode ||
                    "-"
                  }
                </small>

                <h3>
                  {
                    employee?.name ||
                    leave?.employeeName ||
                    "-"
                  }
                </h3>

                <p>
                  {
                    employee?.department ||
                    "-"
                  }
                </p>

              </div>


              <EmployeeStatusBadge
                status={
                  status
                }
              />

            </section>


            <section className="employee-leave-detail-section">

              <h4>
                Leave Information
              </h4>


              <div className="employee-leave-detail-grid">

                <Detail
                  icon={
                    FiCalendar
                  }
                  label="Leave Type"
                  value={
                    leaveType?.name ||
                    leave?.leaveTypeName ||
                    "-"
                  }
                />


                <Detail
                  icon={
                    FiCalendar
                  }
                  label="From Date"
                  value={
                    formatEmployeeDate(
                      leave?.fromDate ||
                      leave?.startDate
                    )
                  }
                />


                <Detail
                  icon={
                    FiCalendar
                  }
                  label="To Date"
                  value={
                    formatEmployeeDate(
                      leave?.toDate ||
                      leave?.endDate
                    )
                  }
                />


                <Detail
                  icon={
                    FiClock
                  }
                  label="Total Days"
                  value={
                    leave?.totalDays ??
                    leave?.days ??
                    0
                  }
                />


                <Detail
                  icon={
                    FiCheck
                  }
                  label="Paid Leave"
                  value={
                    leave?.isPaid
                      ?
                      "Yes"
                      :
                      "No"
                  }
                />


                <Detail
                  icon={
                    FiClock
                  }
                  label="Half Day"
                  value={
                    leave?.halfDay
                      ?
                      "Yes"
                      :
                      "No"
                  }
                />

              </div>

            </section>


            <section className="employee-leave-detail-section">

              <h4>
                Reason
              </h4>

              <p className="employee-leave-reason">
                {
                  leave?.reason ||
                  "-"
                }
              </p>

            </section>


            {
              leave?.remark
                ?
                (
                  <section className="employee-leave-detail-section">

                    <h4>
                      Remark
                    </h4>

                    <p className="employee-leave-reason">
                      {leave.remark}
                    </p>

                  </section>
                )
                :
                null
            }


            {
              leave?.rejectionReason
                ?
                (
                  <section className="employee-leave-detail-section">

                    <h4>
                      Rejection Reason
                    </h4>

                    <div className="employee-leave-rejection-box">
                      {
                        leave.rejectionReason
                      }
                    </div>

                  </section>
                )
                :
                null
            }


            <section className="employee-leave-detail-section">

              <h4>
                Request Information
              </h4>


              <div className="employee-leave-info-grid">

                <div>

                  <span>
                    Applied On
                  </span>

                  <strong>
                    {
                      formatEmployeeDate(
                        leave.createdAt
                      )
                    }
                  </strong>

                </div>


                <div>

                  <span>
                    Status
                  </span>

                  <strong>
                    {status}
                  </strong>

                </div>

              </div>

            </section>

          </div>


          <footer>

            <button
              type="button"
              onClick={
                onClose
              }
            >
              Close
            </button>


            {
              status ===
              "PENDING"
                ?
                (
                  <>
                    <button
                      type="button"
                      className="employee-leave-reject-btn"
                      onClick={
                        () =>
                          onReject?.(
                            leave
                          )
                      }
                    >

                      <FiX />

                      Reject

                    </button>


                    <button
                      type="button"
                      className="employee-leave-approve-btn"
                      onClick={
                        () =>
                          onApprove?.(
                            leave
                          )
                      }
                    >

                      <FiCheck />

                      Approve

                    </button>
                  </>
                )
                :
                null
            }


            {
              [
                "PENDING",
                "APPROVED",
              ].includes(
                status
              )
                ?
                (
                  <button
                    type="button"
                    className="employee-leave-cancel-btn"
                    onClick={
                      () =>
                        onCancel?.(
                          leave
                        )
                    }
                  >

                    <FiXCircle />

                    Cancel

                  </button>
                )
                :
                null
            }

          </footer>

        </aside>

      </div>,

      document.body

    );

};


const Detail = ({
  icon: Icon,
  label,
  value,
}) => (

  <div className="employee-leave-detail-item">

    <span>
      <Icon />
    </span>


    <div>

      <small>
        {label}
      </small>

      <strong>
        {
          value ??
          "-"
        }
      </strong>

    </div>

  </div>

);


export default LeaveDetailsDrawer;